import type { ComponentProps } from 'react';
import React from 'react';

import Button, { type ButtonProps } from './Button';

type ButtonUploadProps = Omit<ButtonProps, 'onClick'> & {
  accept?: ComponentProps<'input'>['accept'];
  multiple?: ComponentProps<'input'>['multiple'];
  onOpenFile?: (file: File) => void;
};

export default function ButtonUpload({ children, onOpenFile, accept, multiple, ...props }: ButtonUploadProps) {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file && onOpenFile != null && file.type === 'text/csv') {
      onOpenFile(file);
    }
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  return (
    <Button {...props} onClick={openFilePicker}>
      {children}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
        accept={accept}
        multiple={multiple}
      />
    </Button>
  );
}
